;(function () {
  var store = Vue.observable({
    viewport: null,
    openMenu: false,
    openCZNList: false,
    cznSelectMode: false,
    currentCzn: null,
    openForm: false,
    openPsihoForm: false,
    langTat: false,
    formSuccess: false,
    invalidMode: false,
    font: 'normal',
    color: 'white'
  })
  var actions = {
    setViewport: function (viewport) {
      store.viewport = viewport
    },
    setOpenMenu: function (val) {
      store.openMenu = val
    },
    setOpenCZNList: function (val, selectMode) {
      store.openCZNList = val
      if (val && selectMode) store.cznSelectMode = true
    },
    setCurrentCzn: function ({ id, name }) {
      store.currentCzn = {
        id,
        name
      }
    },
    setOpenForm: function (val) {
      store.openForm = val
      if (!val) {
        store.cznSelectMode = false
        store.currentCzn = null
      }
    },
    setOpenPsihoForm: function (val) {
      store.openPsihoForm = val
      if (!val) {
        store.cznSelectMode = false
        store.currentCzn = null
      }
    },
    setLangTat: function (val) {
      store.langTat = val
    },
    setFormSuccess: function (val) {
      store.formSuccess = val
    },
    setFont: function (val) {
      if (val && val !== 'null') store.font = val
    },
    setColor: function (val) {
      if (val && val !== 'null') store.color = val
    },
    setCookieInvalid: function (props) {
      if (props.invalidMode !== undefined) {
        setCookie('invalid_version_default', !props.invalidMode, {
          expires: 10000
        })
      }
      if (props.font !== undefined) {
        setCookie('invalid_font', props.font, { expires: 10000 })
      }
      if (props.color !== undefined) {
        setCookie('invalid_color', props.color, { expires: 10000 })
      }
    },
    setInitialInvalidSettings: function () {
      var color = Vue.$cookies.get('invalid_color')
      var font = Vue.$cookies.get('invalid_font')
      var invalidVersionDefault = Vue.$cookies.get('invalid_version_default')
      var invalidMode = invalidVersionDefault === 'false'
      this.setFont(font)
      this.setColor(color && color !== 'null' ? color.replace('-theme', '') : null)
      store.invalidMode = invalidMode
      if (invalidVersionDefault === null) {
        this.setCookieInvalid({
          invalidMode: false,
          font: store.font,
          color: store.color
        })
      }
      if (invalidMode) {
        this.setInvalidAttributes(store.font, store.color + '-theme')
      }
    },
    setInvalidAttributes: function (font, color) {
      $('html').attr('class', font)
      $('body').attr('class', color)
    },
    setInvalidMode: function (val) {
      store.invalidMode = val
      this.setCookieInvalid({
        invalidMode: val
      })
      if (!val) {
        this.setInvalidAttributes('', '')
      } else {
        this.changeFont(store.font, true)
        this.changeColor(store.color, true)
      }
    },
    resetInvalidSettings() {
      store.invalidMode = false
      this.setInvalidAttributes('', '')
      this.setFont('normal')
      this.setColor('white')
      this.setCookieInvalid({
        invalidMode: false,
        font: 'normal',
        color: 'white'
      })
    },
    changeFont: function (font, withoutCookie) {
      var classes = 'null sm normal lg'
      $('html').removeClass(classes.replace(font, ''))
      $('html').addClass(font)
      if (!withoutCookie) {
        this.setCookieInvalid({
          font: font
        })
        this.setFont(font)
      }
    },
    changeColor: function (color, withoutCookie) {
      var classes = 'null white-theme black-theme blue-theme'
      $('body').removeClass(classes.replace(color + '-theme', ''))
      $('body').addClass(color + '-theme')
      if (!withoutCookie) {
        this.setCookieInvalid({
          color: color
        })
        this.setColor(color)
      }
    }
  }
  Vue.prototype.$store = store
  Vue.prototype.$actions = actions
})()
